// extracted by mini-css-extract-plugin
module.exports = {"input":"i_Gu","button":"i_Gv"};